import React from 'react';
import { useTheme } from '@mui/material';
import { paths } from '@/app/routes';
import { ClientNameAndAvatar } from '@/components/table/ClientNameAndAvatar';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';
import { getDealClientId } from '@/features/deals/helper';
import FolioLink from '@/components/FolioLink';

const getDealInitials = (name) => {
	if (!name) {
		return 'NA';
	}

	const names = name.split(' ');

	if (names.length === 2) {
		return names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase();
	}

	return name.length >= 2 ? name.substring(0, 2).toUpperCase() : name.toUpperCase();
};

const WIDTH = 250;

export const DataGridTaskClientName = ({ row }) => {
	const theme = useTheme();
	const { dealId, clientId, clientName, relationshipCompanyId } = row;

	const { data: dealData } = useGetDealRowQuery(dealId, {
		skip: !dealId,
	});

	const resolvedClientId = clientId ?? getDealClientId(dealData);

	const { data: clientData } = useGetClientRowQuery(resolvedClientId, {
		skip: !resolvedClientId,
	});

	const taskOwnerName = clientData?.name || dealData?.dealName || clientName;

	const link = resolvedClientId ? `${paths.clients}/${resolvedClientId}` : null;

	const sharedParams = {
		title: taskOwnerName,
		initials: getDealInitials(taskOwnerName),
		width: WIDTH,
	};

	if (!taskOwnerName) return '-';

	if (!link) {
		return <ClientNameAndAvatar {...sharedParams} />;
	}

	return (
		<FolioLink
			to={link}
			state={{ task: row.id }}
			stopPropagation
			sx={{ display: 'inline-block', cursor: 'pointer' }}
		>
			<ClientNameAndAvatar
				{...sharedParams}
				colour='inherit'
				sx={{
					'&:hover': {
						color: theme.palette.primary.main,
					},
				}}
			/>
		</FolioLink>
	);
};
